// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kredGuruSection_listStyle__SAVBm {
    list-style: decimal;
    padding: 0px 15px;
}

.kredGuruSection_resetButton__apZ2J {
    display: flex;
    width: max-content;
    padding: 16px 24px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 4px;
    background: #5151f9;
    color: #fff;
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    border: 0;
    margin-top: 50px;
}
`, "",{"version":3,"sources":["webpack://./src/_components/kredGuruSection/kredGuruSection.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,kCAAkC;IAClC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB","sourcesContent":[".listStyle {\n    list-style: decimal;\n    padding: 0px 15px;\n}\n\n.resetButton {\n    display: flex;\n    width: max-content;\n    padding: 16px 24px;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n    border-radius: 4px;\n    background: #5151f9;\n    color: #fff;\n    font-family: 'Poppins', sans-serif;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    border: 0;\n    margin-top: 50px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"listStyle": `kredGuruSection_listStyle__SAVBm`,
	"resetButton": `kredGuruSection_resetButton__apZ2J`
};
export default ___CSS_LOADER_EXPORT___;
